import { render, staticRenderFns } from "./IncraSigefPrivado.vue?vue&type=template&id=0f1b85b8&lang=pug"
import script from "./IncraSigefPrivado.vue?vue&type=script&lang=js"
export * from "./IncraSigefPrivado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports